import { useParams } from "react-router-dom";
import ReplaceDataList from "./List.jsx";
import ReplaceDataDetail from "./Detail.jsx";

const ReplaceDataPage = () => {
    const { secondParam } = useParams();

    const Specified = secondParam ? ReplaceDataDetail : ReplaceDataList;

    return <Specified />;
};

export default ReplaceDataPage;
